import request from '@/utils/request'

/**
 * 报价清单新增
 * @param data
 */
export const offerForm = (data) => {
  return request({
    url: '/sol/wap/offerForm',
    method: 'post',
    data: data
  })
}

/**
 * 更新报价清单联系人,电话,系统报价
 * @param data
 */
export const updateContacts = (data) => {
  return request({
    url: '/sol/wap/offerForm/updateContacts/' + data.id,
    method: 'put',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/offerForm/offerForm.js